import { formatStrinWithTimeZoneDateByRegex } from '@ux/mappers/date.mapper';

export interface DateValidator {
  arrival?: Date;
  departure: Date;
  valid: boolean;
}

export function getDaysBetweenDates(start: Date, end: Date): number {
  const one = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate()));
  const two = new Date(Date.UTC(end.getFullYear(), end.getMonth(), end.getDate()));
  one.setHours(0, 0, 0);
  two.setHours(0, 0, 0);
  const diff = two.getTime() - one.getTime();
  return Math.ceil(diff / (1000 * 3600 * 24));
}

export function getUTCDate(date: string): Date {
  const formatStringDate = formatStrinWithTimeZoneDateByRegex(date);
  const dateD = new Date(formatStringDate);
  const dateT = new Date(date);
  const UtcDate = new Date(dateD.getUTCFullYear(), dateD.getUTCMonth(), dateD.getDate(),
    dateT.getUTCHours(), dateT.getUTCMinutes(), dateT.getUTCSeconds());
  return UtcDate;
}
